import styled from "styled-components";

const Map = () => {
  return (
    <Container>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4547.518438216445!2d11.5264211!3d48.110380500000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479dd97cea93dd3b%3A0x7bf501a9eada6144!2sEra%20Aesthetics%20%26%20Academy!5e1!3m2!1sen!2s!4v1770822011376!5m2!1sen!2s"
        style={{ border: 0 }}
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </Container>
  );
};
const Container = styled.div`
  width: 100%;
  margin: 5em 0;
  display: flex;
  justify-content: center;
  iframe {
    align-items: center;
    display: flex;
    width: auto;
    justify-content: center;
    width: 60%;
    height: 600px;
  }
  @media (max-width: 700px) {
    iframe {
      width: 95%;
      height: 500px;
    }
  }
`;

export default Map;
